import { useParams } from 'react-router-dom';
import { services, cities, industries, products } from '../data/seoPages';
import ServiceLocationPage from './ServiceLocationPage';
import IndustryLocationPage from './IndustryLocationPage';
import ProductPage from './ProductPage';

export default function DynamicSeoPage() {
  const { slug } = useParams();
  
  // Check if it's a product page
  const product = products.find(p => p.slug === slug);
  if (product) {
    return <ProductPage />;
  }
  
  // Check if it's a service + location page
  for (const service of services) {
    for (const city of cities) {
      if (slug === `${service.slug}-${city.slug}`) {
        return <ServiceLocationPage />;
      }
    }
  }
  
  // Check if it's an industry + location page
  for (const industry of industries) {
    for (const city of cities) {
      if (slug === `${industry.slug}-${city.slug}`) {
        return <IndustryLocationPage />;
      }
    }
  }
  
  // Return 404 for unknown slugs
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-800 mb-4">404</h1>
        <p className="text-gray-600 mb-4">Page not found</p>
        <a href="/" className="text-orange-500 hover:underline">Return to Home</a>
      </div>
    </div>
  );
}
